import React from 'react'
import Header from "./header";
import Footer from "../footer/footer";
import { Navbar, Nav, Container, NavDropdown, Form, FormControl, Button } from 'react-bootstrap';
import logo from "../../assets/images/logo.svg";
import { useNavigate } from 'react-router-dom';

function Aboutpage() {
  const navigate = useNavigate();

  return (
    <div>
      <Navbar expand="lg" className="home_data">
        <Container fluid>
          <Navbar.Brand href="/" className="col-6">
            <img
              src={logo} className='site_logo'
              style={{ display: 'block', margin: 'auto' }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-lg-0 menu col-6"
              style={{ maxHeight: '100px' }}
              navbarScroll
            >
              <Nav.Link onClick={() => navigate('/')} className="px-5 text-white">Home</Nav.Link>
              <Nav.Link onClick={() => navigate('/aboutpage')} className="px-5 text-white active">About</Nav.Link>
              <Nav.Link onClick={() => navigate('/membership')} href="#" className="px-5 text-white">Membership</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className='aboutpage_bg d-flex'>
        <div className='col-6 '></div>
        <div className='col-6 p-5 d-none d-lg-block'><h2 className='text-center mb-5'>About Us</h2>
          <h5>Redated – Your Gateway to Timeless Connections </h5>

          <p>At Redated, we believe that while time may pass, love is eternal. Our mission is to provide a secure and welcoming platform where you can connect with incredible matches both near and far, unlocking the transformative power of love to create a lifetime of happiness.</p>


          <p>Say goodbye to awkward online dating experiences and step into a community that fosters genuine connections, both online and in real life. Redated is where real magic happens—where adventures begin, love blossoms, and soulmates meet. The possibilities are endless.</p>

          <p>Your safety is our top priority. We’ve established comprehensive guidelines to ensure a secure environment for all our members. Our dedicated team is always here to support and guide you every step of the way.</p>

          <p>Don’t wait for love to find you—take the leap with Redated and make it happen. Your journey toward timeless connections starts here.</p>

        </div>
      </div>
      <div>
      <div className='p-3 d-block d-lg-none'><h2 className='text-center mb-3'>About Us</h2>
          <p>
            Time devours all things but love. . . </p>

          <p>Redated takes great pride in giving you a safe platform  to connect with amazing matches in your area and beyond </p>


          <p>We will help you harness the intoxicating power of love to create happiness that endures a lifetime</p>

          <p>Forget the days of awkward online
            Dating and become part of a community where you can create real magic online and IRL</p>

          <p> We have guidelines in place to protect each and every one of our members. Your safety is our priority. Our team is always here to be at your service</p>

          <p>Dating is a way to walk the path you were destined to. It can lead to adventures , love , your soul mate. The possibilities are endless …</p>

        </div>
      </div>
      <Footer />
    </div>

  )
}

export default Aboutpage;